<template>
  <div class="land">
    <div class="sheet">
      <div class="badge">❤ {{ $t('land.brand') }}</div>

      <div class="hero">
        <img :src="heroPic" alt="" @error="heroPic = '/img/c1.png'">
        <div class="hero-mask">
          <div class="hero-title">{{ $t('land.hero_title') }}</div>
          <div class="hero-sub">❤ {{ $t('land.hero_sub') }}</div>
        </div>
      </div>

      <div class="copy">
        <p>{{ $t('land.p1') }}</p>
        <p>{{ $t('land.p2') }}</p>
        <p>{{ $t('land.p3') }}</p>
        <p>{{ $t('land.p4') }}</p>
        <p class="accent">❤ {{ $t('land.p5') }}</p>
      </div>

      <div class="photo">
        <img :src="midPic" alt="" @error="midPic = '/img/home/cs.png'">
      </div>

      <div class="copy">
        <p>{{ $t('land.p6') }}</p>
        <p>{{ $t('land.p7') }}</p>
        <p>{{ $t('land.p8') }}</p>
        <p>{{ $t('land.p9') }}</p>
        <p>{{ $t('land.p10') }}</p>
      </div>

      <div class="photo">
        <img :src="couplePic" alt="">
      </div>

      <div class="copy">
        <p class="lead">{{ $t('land.p11_head') }}</p>
        <p>{{ $t('land.p11') }}</p>
        <p>{{ $t('land.p12') }}</p>
        <p>{{ $t('land.p13') }}</p>
        <p>{{ $t('land.p14') }}</p>
        <p>{{ $t('land.p15') }}</p>
        <p>{{ $t('land.p16') }}</p>
        <p>{{ $t('land.p17') }}</p>
        <p>{{ $t('land.p18') }}</p>
        <p>{{ $t('land.p19') }}</p>
      </div>

      <div class="cta" @click="goChoose">{{ $t('land.cta') }}</div>

      <div class="copy">
        <p>{{ $t('land.i1') }}</p>
        <p>{{ $t('land.i2') }}</p>
        <p>{{ $t('land.i3') }}</p>
        <p>{{ $t('land.i4') }}</p>
        <p>{{ $t('land.i5') }}</p>
      </div>

      <div class="city" v-for="item in cityCards" :key="item.id" @click="toDetail(item.id)">
        <img :src="item.img_url" alt="" @error="onPicError($event, '/img/home/cs.png')">
        <div class="city-body">
          <div class="city-name">{{ item.class_name }}</div>
          <div class="city-tag">{{ item.xuanfei_name }}</div>
          <div class="city-desc" v-if="item.intro">{{ item.intro }}</div>
        </div>
      </div>

      <div class="steps">
        <div class="step">
          <img :src="step1Pic" alt="">
          <div>
            <div class="step-kicker">STEP 01</div>
            <div class="step-name">{{ $t('land.step1_title') }}</div>
            <p>{{ $t('land.step1_text') }}</p>
          </div>
        </div>
        <div class="step">
          <img :src="step2Pic" alt="">
          <div>
            <div class="step-kicker">STEP 02</div>
            <div class="step-name">{{ $t('land.step2_title') }}</div>
            <p>{{ $t('land.step2_text') }}</p>
          </div>
        </div>
      </div>

      <div class="cta slim">{{ $t('land.voice') }}</div>

      <div class="voice" v-for="v in voiceList" :key="v.id">
        <div class="avatar"></div>
        <div>
          <div class="who">{{ $t('land.' + v.id + '_who') }}</div>
          <div class="job">{{ $t('land.' + v.id + '_job') }}</div>
          <p>{{ $t('land.' + v.id + '_text') }}</p>
          <p v-if="v.long">{{ $t('land.' + v.id + '_long') }}</p>
        </div>
      </div>

      <div class="crown">
        <img src="/img/vip.png" alt="">
        <div class="crown-kicker">{{ $t('land.crown_kicker') }}</div>
        <div class="crown-name">{{ $t('land.crown_name') }}</div>
        <div class="rank">
          <div v-for="n in 6" :key="n">
            <span>{{ $t('land.r' + n) }}</span>
            <b>1{{ $t('land.rank_unit') }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datalist: [],
      banners: [],
      heroPic: '/img/c1.png',
      midPic: '/img/home/cs.png',
      couplePic: '/img/login/login.png',
      step1Pic: '/img/home/m1.png',
      step2Pic: '/img/home/m2.png',
      voiceList: [
        { id: 'v1' },
        { id: 'v2', long: true },
        { id: 'v3', long: true },
        { id: 'v4' },
        { id: 'v5' },
        { id: 'v6' },
      ],
    };
  },
  computed: {
    cityCards() {
      const pics = ['/img/home/cs.png', '/img/c1.png', '/img/home/g1.png', '/img/login/login.png', '/img/home/m2.png', '/img/home/m1.png'];
      const defaults = [1, 2, 3, 4, 5, 6].map((n, i) => ({
        id: 'c' + n,
        img_url: pics[i],
        class_name: this.$t('land.c' + n + '_name'),
        xuanfei_name: this.$t('land.c' + n + '_tag'),
        intro: this.$t('land.c' + n + '_desc'),
      }));
      if (!this.datalist.length) return defaults;
      return this.datalist.slice(0, 6).map((item, i) => ({
        id: item.id || defaults[i].id,
        img_url: item.img_url || defaults[i].img_url,
        class_name: item.class_name || defaults[i].class_name,
        xuanfei_name: item.xuanfei_name || defaults[i].xuanfei_name,
        intro: item.intro || defaults[i].intro,
      }));
    },
  },
  methods: {
    onPicError(e, fallback) {
      if (!e || !e.target || !fallback) return;
      if (String(e.target.src).indexOf(fallback) >= 0) return;
      e.target.src = fallback;
    },
    goChoose() {
      this.$router.push('/Choose');
    },
    toDetail(id) {
      if (!id || String(id).indexOf('c') === 0) {
        this.goChoose();
        return;
      }
      this.$router.push({ path: '/detail', query: { id } });
    },
    getBasicConfig() {
      this.$http({ method: 'get', url: 'sys_config' }).then((res) => {
        if (!res || !res.data) return;
        this.banners = res.data.banners || [];
      });
    },
    getxuanfeilist() {
      this.$http({ method: 'get', url: 'xuanfeilist1', data: { id: 0, page: 1 } }).then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        this.datalist = list;
      });
    },
  },
  created() {
    document.title = this.$t('land.brand');
    this.getBasicConfig();
    this.getxuanfeilist();
  },
};
</script>

<style scoped>
.land {
  min-height: 100vh;
  background: #f4e9df;
  padding: 24px 18px 160px;
}
.sheet {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(80, 40, 20, 0.08);
  padding-bottom: 48px;
}
.badge {
  width: 420px;
  margin: 28px auto 18px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  border-radius: 28px;
  background: linear-gradient(90deg, #ff4d88, #ff2d6f);
}
.hero, .photo {
  position: relative;
  overflow: hidden;
}
.hero img, .photo img {
  display: block;
  width: 100%;
  height: 520px;
  object-fit: cover;
}
.hero-mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 48px 36px 36px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(20, 8, 12, 0.72));
  color: #fff;
}
.hero-title {
  font-size: 48px;
  font-weight: 800;
  letter-spacing: 2px;
}
.hero-sub {
  margin-top: 10px;
  font-size: 28px;
}
.copy {
  padding: 36px 40px 8px;
  color: #3b4252;
  font-size: 28px;
  line-height: 1.75;
}
.copy p { margin: 0 0 28px; }
.copy .lead {
  font-size: 32px;
  font-weight: 800;
  color: #222;
  margin-bottom: 16px;
}
.copy .accent { color: #d6336c; font-weight: 600; }
.cta {
  margin: 12px 32px 8px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
  border-radius: 8px;
  background: #ff2d6f;
}
.cta.slim { margin-top: 16px; }
.city {
  margin: 12px 32px 0;
  display: flex;
  border: 3px solid #f7a8c4;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
}
.city img {
  width: 160px;
  height: 160px;
  object-fit: cover;
  flex: none;
}
.city-body { padding: 14px 16px; }
.city-name { color: #e11d74; font-size: 28px; font-weight: 800; }
.city-tag { margin-top: 4px; font-size: 24px; font-weight: 700; color: #333; }
.city-desc {
  margin-top: 6px;
  font-size: 22px;
  color: #666;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.steps {
  margin: 16px 32px 0;
  background: #eef6fb;
  border-radius: 12px;
  overflow: hidden;
}
.step {
  display: flex;
  padding: 16px;
  border-bottom: 1px solid #d7e6f0;
}
.step:last-child { border-bottom: 0; }
.step img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 16px;
  flex: none;
}
.step-kicker {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 6px;
  background: #3b82f6;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}
.step-name { margin-top: 8px; font-size: 30px; font-weight: 800; color: #1e3a5f; }
.step p { margin: 8px 0 0; font-size: 24px; color: #4b5563; line-height: 1.55; }
.voice {
  margin: 12px 32px 0;
  display: flex;
  padding: 16px;
  border: 3px solid #f7a8c4;
  border-radius: 14px;
}
.avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin-right: 16px;
  flex: none;
  background: #efe6c9 url(/img/shangchang/touxiang/photo_2026-10-15_23-00-46.jpg) center / cover no-repeat;
}
.who { font-size: 28px; font-weight: 800; color: #222; }
.job { margin-top: 4px; color: #e11d74; font-size: 24px; }
.voice p { margin: 10px 0 0; font-size: 24px; color: #555; line-height: 1.55; }
.crown { margin: 24px 32px 0; text-align: center; }
.crown img { width: 160px; }
.crown-kicker { margin-top: 8px; color: #888; font-size: 24px; }
.crown-name { font-size: 40px; font-weight: 800; color: #1e3a5f; }
.rank { margin-top: 16px; }
.rank > div {
  display: flex;
  justify-content: space-between;
  padding: 10px 40px;
  font-size: 26px;
  color: #444;
  border-bottom: 1px solid #eee;
}
.rank b { color: #e11d74; }
</style>
